import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_ninja: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-ninja" {...rest}>
      <title>praise-ninja</title>
      <circle fill="#8CC63F" cx="75" cy="75" r="75"></circle>
      <circle fill="#343A41" cx="71.6" cy="75.2" r="50.2"></circle>
      <g fill="#343A41">
        <path d="M141.5 78.4s-5.9 2-12.8-.3c-6.8-2.3-10.5-9.8-10.5-9.8s6.5-1.1 13.4 1.2c6.8 2.3 9.9 8.9 9.9 8.9z"></path>
        <path d="M142.7 62.1s-3.5 5.2-10.3 7.6-14.3-1.3-14.3-1.3 4.5-4.9 11.3-7.2c6.9-2.4 13.3.9 13.3.9z"></path>
      </g>
      <path
        fill="#F5FAFA"
        d="M26 75.5c0 5.3.9 12.5 2.6 15.5h85.9c1.7-3 2.6-10.2 2.6-15.5 0-3.1-.3-6.5-.9-9.5H26.9c-.6 3-.9 6.3-.9 9.5z"
      ></path>
      <circle fill="#343A41" cx="48.7" cy="78.5" r="4.8"></circle>
      <circle fill="#343A41" cx="94.5" cy="78.5" r="4.8"></circle>
    </svg>
  );
};
